import { cmsAxios } from "./config/axiosConfig";

export interface AdminUser {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  designation: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  roleId: string;
  roleIds: {
    roleName: string;
  };
}

export interface AdminListResponse {
  success: boolean;
  data: AdminUser[];
}

export const getAdminList = async (): Promise<{
  success: boolean;
  data?: AdminUser[];
  message?: string;
}> => {
  try {
    const response = await cmsAxios.get<AdminListResponse>("/cms/admin/list");

    return {
      success: response.data.success,
      data: response.data.data,
    };
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to fetch admin list",
    };
  }
};

export const createAdmin = async (payload: {
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  password: string;
  designation: string;
  roleId: string;
}) => {
  try {
    const res = await cmsAxios.post("cms/admin/create", payload);

    if (!res.data?.success) {
      throw new Error(res.data?.data || "Failed to create admin");
    }

    return res.data;
  } catch (err: any) {
    throw new Error(err.response?.data?.data || "Failed to create admin");
  }
};

// Update Admin
export const updateAdmin = async (
  adminId: string,
  payload: {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    email?: string;
    designation?: string;
    isActive?: boolean;
    roleId: string;
  }
) => {
  try {
    const res = await cmsAxios.put(`/cms/admin/${adminId}`, payload);
    return res.data;
  } catch (err: any) {
    console.error("Error updating admin:", err);
    throw err;
  }
};

export interface CmsRole {
  id: string;
  roleName: string;
  description?: string;
}

export interface CmsRolesResponse {
  success: boolean;
  data: CmsRole[];
}

export const fetchCmsRolesList = async (): Promise<CmsRolesResponse> => {
  try {
    const response = await cmsAxios.get<CmsRolesResponse>("/cms/roles/list");
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch CMS roles list"
    );
  }
};

// Reset Admin Password
export const resetAdminPassword = async (
  adminId: string,
  payload: { password: string }
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    const response = await cmsAxios.put(
      `/cms/admin/reset-password/${adminId}`,
      payload
    );

    return {
      success: response.data?.success ?? true,
      data: response.data?.data,
    };
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to reset admin password",
    };
  }
};
